import axios from "axios";

// En producción se define REACT_APP_API_URL (ej: https://api.tudominio.com).
// En desarrollo, si no está definida, usa el backend local.
const _hostApi = process.env.REACT_APP_API_URL || "http://localhost:5196";
const _urlBase = `${_hostApi}/api`;

const _api = axios.create({
  baseURL: _urlBase,
  headers: {
    "Content-Type": "application/json",
  },
});

_api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

_api.interceptors.response.use(
  (respuesta) => respuesta,
  (error) => {
    if (!error.response) {
      console.error("No se pudo conectar con el servidor. Verifica que el backend este corriendo.");
    }
    return Promise.reject(error);
  }
);

export const authService = {
  registro: (datos) => _api.post("/Auth/registro", datos),
  login: (datos) => _api.post("/Auth/login", datos),
  loginGoogle: (credential) => _api.post("/Auth/google", { credential }),
  olvidePassword: (email) => _api.post("/Auth/olvide-password", { email }),
  resetearPassword: (token, nuevaPassword) =>
    _api.post("/Auth/resetear-password", { token, nuevaPassword }),
  completarPerfil: (telefono, instagram) =>
    _api.put("/Auth/completar-perfil", { telefono, instagram }),
};

export const turnosService = {
  obtenerMisTurnos: () => _api.get("/Turnos/mis-turnos"),
  obtenerDisponibles: (fecha, servicio) =>
    _api.get(`/Turnos/disponibles?fecha=${fecha}&servicio=${servicio}`),
  crearTurno: (datos) => _api.post("/Turnos", datos),
  cancelarTurno: (id) => _api.delete(`/Turnos/${id}`),
};

export const adminService = {
  obtenerDashboard: () => _api.get("/Admin/dashboard"),
  obtenerTodosTurnos: () => _api.get("/Admin/turnos"),
  obtenerClientas: () => _api.get("/Admin/clientas"),
  agregarTurno: (datos) => _api.post("/Admin/agregar-turno", datos),
  agregarClienta: (datos) => _api.post("/Admin/agregar-clienta", datos),
  cambiarEstadoTurno: (id, estado) =>
    _api.put(`/Admin/turno/${id}/estado`, JSON.stringify(estado)),
  actualizarNotasClienta: (id, notas) =>
    _api.put(`/Admin/clientas/${id}/notas`, { notas }),
  actualizarInstagramClienta: (id, instagram) =>
    _api.put(`/Admin/clientas/${id}/instagram`, { instagram }),
  hacerAdmin: (id) => _api.put(`/Admin/clientas/${id}/hacer-admin`),
};

export const ingresosService = {
  obtenerTodos: () => _api.get("/Ingresos"),
  obtenerResumen: () => _api.get("/Ingresos/resumen"),
  agregarIngreso: (datos) => _api.post("/Ingresos", datos),
  eliminarIngreso: (id) => _api.delete(`/Ingresos/${id}`),
};

export const serviciosService = {
  obtenerTodos: () => _api.get("/Servicios"),
  crear: (datos) => _api.post("/Servicios", datos),
  editar: (id, datos) => _api.put(`/Servicios/${id}`, datos),
  eliminar: (id) => _api.delete(`/Servicios/${id}`),
};

export const galeriaService = {
  obtenerTodas: () => _api.get("/Galeria"),
  subirFoto: (archivo, categoria) => {
    const _formData = new FormData();
    _formData.append("archivo", archivo);
    _formData.append("categoria", categoria);
    return _api.post("/Galeria", _formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  eliminarFoto: (id) => _api.delete(`/Galeria/${id}`),
};

export const diasBloqueadosService = {
  obtenerTodos: () => _api.get("/DiasBloqueados"),
  crear: (datos) => _api.post("/DiasBloqueados", datos),
  eliminar: (id) => _api.delete(`/DiasBloqueados/${id}`),
};

export const fotosServiciosService = {
  obtenerTodas: () => _api.get("/FotosServicios"),
  subir: (archivo, clave) => {
    const _formData = new FormData();
    _formData.append("archivo", archivo);
    _formData.append("clave", clave);
    return _api.post("/FotosServicios", _formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};

export const URL_FOTOS = `${_hostApi}/fotos`;

export default _api;